import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, Inject,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {TranslationService} from './modules/i18n/translation.service';
import {SplashScreenService} from './_metronic/partials/layout/splash-screen/splash-screen.service';
import {TableExtendedService} from './_metronic/shared/crud-table';
import {LoadingService} from './core/_util/loading.service';
import {delay, filter, map} from 'rxjs/operators';
import {OKTA_AUTH, OktaAuthStateService} from '@okta/okta-angular';
import {AuthState} from '@okta/okta-auth-js';

@Component({
  standalone: false,
    // tslint:disable-next-line:component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
    private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
    loading = false;

    constructor(
        private translationService: TranslationService,
        private splashScreenService: SplashScreenService,
        private loadingService: LoadingService,
        private router: Router,
        private tableService: TableExtendedService,
        private cdr: ChangeDetectorRef,
        private _oktaStateService: OktaAuthStateService
    ) {
    }


    ngOnInit() {
        this._oktaStateService.authState$.pipe(
            filter((s: AuthState) => !!s),
            map((s: AuthState) => {
                return s.isAuthenticated ?? false
            })
        ).subscribe();
        localStorage.removeItem('customerInfoView');
        const routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // clear filtration paginations and others
                this.tableService.setDefaults();
                // hide splash screen
                this.splashScreenService.hide();

                // scroll to top on every route change
                window.scrollTo(0, 0);

                // to display back the body content
                setTimeout(() => {
                    document.body.classList.add('page-loaded');
                }, 500);
            }
        });
        this.unsubscribe.push(routerSubscription);
        this.listenToLoading();
    }

    listenToLoading(): void {
        this.loadingService.loadingSub
            .pipe(delay(0))
            .subscribe((loading) => {
                if (!this.splashScreenService.stopped && !loading) {
                    this.loading = false;
                } else if (this.splashScreenService.stopped) {
                    this.loading = loading;
                }
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy() {
        this.unsubscribe.forEach((sb) => sb.unsubscribe());
    }
}
